'use client';

import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { OBJECT_EDIT_FIELD_GROUP_TWO_COLUMN_MIN_WIDTH_PX } from './objectEditLayoutTokens';
import { useContainerMinWidthLayout } from '../useContainerMinWidthLayout';

type ObjectEditMeasureContextValue = {
  isTwoColumnLayout: boolean;
  setMeasureElement: (element: HTMLDivElement | null) => void;
};

const ObjectEditMeasureContext =
  createContext<ObjectEditMeasureContextValue | null>(null);

export function useObjectEditMeasureLayout(): boolean {
  return useContext(ObjectEditMeasureContext)?.isTwoColumnLayout ?? true;
}

type ObjectEditMeasureProviderProps = {
  children: ReactNode;
};

export function ObjectEditMeasureProvider({
  children,
}: ObjectEditMeasureProviderProps) {
  const { setContainerRef, meetsMinWidth: isTwoColumnLayout } =
    useContainerMinWidthLayout(OBJECT_EDIT_FIELD_GROUP_TWO_COLUMN_MIN_WIDTH_PX);

  const value = useMemo(
    () => ({
      isTwoColumnLayout,
      setMeasureElement: setContainerRef,
    }),
    [isTwoColumnLayout, setContainerRef],
  );

  return (
    <ObjectEditMeasureContext.Provider value={value}>
      {children}
    </ObjectEditMeasureContext.Provider>
  );
}

export function useObjectEditMeasureElementRef() {
  return useContext(ObjectEditMeasureContext)?.setMeasureElement ?? null;
}
